import { createSelector } from 'utils/app.util';

export const getIncidentsFromState = createSelector(
  (state) => state.getIn(['projects', 'incidents', 'data']),
  (incidents) => incidents,
);
